export default function Programs() {
  const programs = [
    {
      id: 1,
      title: '유아·아동 상담',
      icon: 'ri-bear-smile-line',
      color: 'bg-[#FFE5E5]',
      description: '놀이와 정서 중심 상담을 통해 아이의 마음을 이해하고 건강한 성장을 돕습니다.'
    },
    {
      id: 2,
      title: '청소년 상담',
      icon: 'ri-palette-line',
      color: 'bg-[#E5F4FF]',
      description: '학교생활과 또래관계의 어려움을 함께 해결하며 정서적 안정을 찾아갑니다.'
    },
    {
      id: 3,
      title: '성인 상담',
      icon: 'ri-user-heart-line',
      color: 'bg-[#FFF4E5]',
      description: '자존감, 진로, 관계 문제 등 성인기의 다양한 고민을 함께 탐색합니다.'
    },
    {
      id: 4,
      title: '부부 상담',
      icon: 'ri-heart-line',
      color: 'bg-[#F0E5FF]',
      description: '서로의 감정을 이해하고 의사소통을 회복하여 관계를 개선합니다.'
    },
    {
      id: 5,
      title: '가족 상담',
      icon: 'ri-home-heart-line',
      color: 'bg-[#E5FFF0]',
      description: '가족 구성원 간의 이해를 돕고 건강한 관계 회복을 지원합니다.'
    },
    {
      id: 6,
      title: '기업 상담',
      icon: 'ri-building-4-line',
      color: 'bg-[#E5F0FF]',
      description: '직장 내 스트레스, 번아웃, 대인관계 갈등 등 직장인의 심리적 건강을 지원하고 조직 내 소통을 돕습니다.'
    }
  ];

  return (
    <section id="programs" className="py-20 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-[26px] font-bold text-[#2C2C2C] mb-3">상담 프로그램</h2>
          <p className="text-[15px] text-[#666666]">
            유아 · 아동 · 청소년 · 성인 · 부부 · 가족 · 기업
          </p>
          <p className="text-[13px] text-[#888888] mt-2">
            연령과 상황에 맞는 전문적인 상담을 제공합니다.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((program) => (
            <div
              key={program.id}
              className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              onClick={() => {
                const el = document.getElementById('booking');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className={`w-12 h-12 ${program.color} rounded-full flex items-center justify-center mb-4`}>
                <i className={`${program.icon} text-2xl text-[#2C2C2C]`}></i>
              </div>
              
              <h3 className="text-[16px] font-bold text-[#2C2C2C] mb-2">{program.title}</h3>
              
              <div className="w-8 h-0.5 bg-[#A8B5A0] mb-3"></div>
              
              <p className="text-[13px] text-[#666666] leading-relaxed">
                {program.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
